import { retry } from 'actions/pending'
import createTypes from 'constants/createTypes'
import { selectLoggedIn } from 'selectors/auth'
import type { MiddlewareStoreShape, NextFn, ReceiveFailTypeGroup } from 'types/adapters'


type CreateType = ReceiveFailTypeGroup

type RetryAction = {
  type?: string
  meta?: {
    retry?: boolean
  }
}

type RetryState = {
  pendingActions?: {
    enabled?: boolean
  }
}

type MiddlewareStore = MiddlewareStoreShape<RetryState>


const createReceiveTypes = (createTypes as CreateType[]).map((a: CreateType) => a.RECEIVE)
const createFailTypes = (createTypes as CreateType[]).map((a: CreateType) => a.FAIL)

export default (store: MiddlewareStore) => (next: NextFn<RetryAction>) => (action: RetryAction) => {
  const { enabled } = store.getState().pendingActions || {}
  const ret = next(action)
  const { loggedIn } = selectLoggedIn(store.getState())
  const actionType = action.type || ''
  if (!enabled) {
    return ret
  }
  if (!loggedIn) {
    return ret
  }
  if (!(action.meta?.retry || createReceiveTypes.includes(actionType) || createFailTypes.includes(actionType))) {
    return ret
  }
  store.dispatch(retry())
  return ret
}
